import { FeatureFlagKey } from "encamp-shared/src/featureFlags";

/**
 * The feature flag governing a submission's guided stepper flow. The two
 * stepper flags are fully independent: submissions with interactive-stepper
 * steps are gated by the interactive-stepper flag, everything else (document
 * forms, including combos like 8700-12 that share an interactive archetype
 * but were created or backfilled without interactive steps) is gated by the
 * document-stepper flag. Keyed on the submission's actual persisted steps
 * (`usesInteractiveStepper`), not its `(type, method)` combo — a submission's
 * archetype is decided once, when its steps are created, and never re-derives
 * from the live flag. Shared by the stepper shell's redirect guard and the
 * submissions-list row links so both route on the same decision.
 */
export function stepperFlagForSubmission(usesInteractiveStepper: boolean): FeatureFlagKey {
  return usesInteractiveStepper
    ? FeatureFlagKey.WasteSubmissionStepper
    : FeatureFlagKey.WasteDocumentSubmissionStepper;
}
